export enum YES_NO {
    YES = 'Y',
    NO = 'N',
}
